import {
    NavLink
  } from "react-router-dom";

import {ReactComponent as Logo } from '../img/logo.svg';
import Navigation from '../components/Navigation';


// export async function loader() {
//   const pacientes = await API.getAllPacientes();
//   return { pacientes };
// }

export function ForbiddenPage() {
  const isAuthenticated = !!sessionStorage.getItem("token");
  return (
    <>
      
      <div id="sidebar">
      {/* <Login /> */}
        <div className="logo"><Logo /></div>
        
        {/* other code */}


        {/* other code */}
      </div>
      { isAuthenticated ? (
      <main id="main">
        {/* <Navigation /> */}
        <div id="detail">
          <div id='content' className='login-page'>
            <h1>No tiene permisos suficientes para visualizar esta sección</h1>
          </div>
        </div>
      </main>
      ) : (
      <main id="main">
        <div id="detail">
          <div id='content' className='login-page'>
            <h1>No tiene permisos suficientes para visualizar esta sección</h1>
          </div>
        </div>
      </main>
      ) }
    </>
  );
}